import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "border-t border-gray-200 px-4 flex items-center justify-between sm:px-0"
}
const _hoisted_2 = { class: "-mt-px w-0 flex-1 flex" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "mr-3 h-5 w-5 text-brand-gray",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_4 = { class: "hidden md:-mt-px md:flex" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "-mt-px w-0 flex-1 flex justify-end" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "ml-3 h-5 w-5 text-brand-gray",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.maxNumberOfPages > 1)
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.currentPage > 0)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "border-t-2 border-transparent pt-4 pr-1 inline-flex items-center text-sm font-medium text-brand hover:border-gray-300 cursor-pointer",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.lastPage()))
              }, [
                _hoisted_3,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("catalog.pagination.prev")), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maxNumberOfPages, (pageIdx) => {
            return (_openBlock(), _createElementBlock("div", { key: pageIdx }, [
              _createElementVNode("span", {
                class: _normalizeClass(["border-transparent text-brand hover:border-gray-300 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium cursor-pointer", {
            'border-brand-promo-bg text-brand-promo-bg':
              _ctx.currentPage == pageIdx - 1,
          }]),
                onClick: ($event: any) => (_ctx.selectPage(pageIdx - 1))
              }, _toDisplayString(pageIdx), 11, _hoisted_5)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.currentPage < _ctx.maxNumberOfPages - 1)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "border-t-2 border-transparent pt-4 pl-1 inline-flex items-center text-sm font-medium text-brand hover:border-gray-300 cursor-pointer",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.nextPage()))
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t("catalog.pagination.next")) + " ", 1),
                _hoisted_7
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}